export default function initStepsLineHeight() {
  function updateHeights() {
    const isPresent = document.querySelector(".experience-module-intro-block");
    if (!isPresent) {
      return;
    }

    const modules = document.querySelectorAll(".experience-module");

    modules.forEach((module) => {
      const introBlock = module.querySelector(".experience-module-intro-block");
      const stepsLine = module.querySelector(".steps-line-one");

      if (introBlock && stepsLine) {
        const introBlockHeight = introBlock.offsetHeight;
        const newHeight = introBlockHeight + 80;
        stepsLine.style.height = `${newHeight}px`;
      }
    });
  }

  // Run on page load
  updateHeights();

  // Update heights on window resize
  window.addEventListener("resize", updateHeights);
}
